<template>
  <div class="live-tracker-master-wrapper">

    <template v-if="matchData">
      <div class="tracker-card position-relative">
        <!-- The hero also stays on mobile for sports without a MatchTracker. -->
        <MatchHero :event="matchData" :hide-timer="hasTracker" v-if="!isMobileOnly || !hasTracker"/>

        <!-- Mobile: the hero is hidden, its scoreboard (names, score,
             periods) stays above the court for tennis, table tennis and
             basketball. -->
        <div v-if="showBoard" class="tracker-scoreboard">
          <ScoreboardLive :sport-id="matchData.sportId" :livescore="matchData.livescore"
                          :competitors="{home: matchData.home, away: matchData.away}" mode="board"/>
        </div>

        <!-- Mobile: the match panel takes the hero's place (on desktop it
             sits in the right column, see LiveMatchTracker). No momentum
             header under the scoreboard. -->
        <MatchCenter v-if="isMobileOnly" :match-data="matchData" :event-id="eventId" :sport-id="initialSportId" :show-momentum="!showBoard" />
      </div>
    </template>

    <div v-else class="tracker-card d-flex flex-column align-center justify-center pa-10" style="min-height: 300px; background: #0c0c0c; border-radius: 20px; border: 1px solid #1f1f1f;">
      <v-progress-circular indeterminate color="#00e5ff" size="40"></v-progress-circular>
      <div class="mt-4 grey--text caption text-uppercase font-weight-bold">{{ $t('statistics.livesync') }}</div>
    </div>

  </div>
</template>

<script>
import MatchHero from "@/components/center_widgets/Live/TradeTracker/MatchHero.vue";
import MatchCenter from "@/components/generic/MatchCenter.vue";
import ScoreboardLive from "@/components/center_widgets/Live/previews/ScoreboardLive.vue";
import {hasMatchTracker} from "@/services/matchtracker/matchTrackerSports";
import {mapGetters} from "vuex";
import {isMobileOnly} from "mobile-device-detect";

// Tennis, table tennis, basketball, Aussie rules.
const BOARD_SPORT_IDS = ['54094', '265917', '48242', '1149105', '1149097', '389537'];

export default {
  components: {
    MatchHero,
    MatchCenter,
    ScoreboardLive
  },
  props: {
    initialSportId: { type: [String, Number], required: true },
    eventId: { type: [String, Number], required: true }
  },
  data() {
    return {
      isMobileOnly: isMobileOnly,
    };
  },
  computed: {
    ...mapGetters({
      'getEventsLiveDetail': 'detailLive/getEventsLiveDetail',
      'getUiPersonalizationGeneral': 'settings/getUiPersonalizationGeneral',
    }),
    matchData() {
      return this.getEventsLiveDetail[0]?.event;
    },
    // MatchTracker only when the skin enables it, for the sports it has a scene for.
    hasTracker() {
      return hasMatchTracker(this.matchData?.sportId ?? this.initialSportId, this.getUiPersonalizationGeneral);
    },
    // Tennis, table tennis and basketball on mobile, when the hero is hidden.
    showBoard() {
      const sportId = String(this.matchData?.sportId ?? this.initialSportId);
      return this.isMobileOnly && this.hasTracker && !!this.matchData?.livescore && BOARD_SPORT_IDS.includes(sportId);
    }
  }
}
</script>

<style scoped>
.live-tracker-master-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px; /* Spazio netto tra le due sezioni desktop */
}

.position-relative { position: relative; }

.tracker-card {
  width: 100%;
  margin: 0 auto;
  background: transparent;
  border-radius: 12px;
  color: #fff;
  font-family: sans-serif;
  overflow: visible;
}

.tracker-scoreboard {
  padding: 8px 12px;
  background: var(--bg-body);
  color: var(--text-platform);
}

/* Margin per staccare visivamente la seconda card */
.desktop-tracker-section {
  margin-top: 8px;
  clear: both;
}
</style>